import React from "react";
import Home from "../pages/home";
import Buy from "../pages/buy";
import Prices from "../pages/prices";
import Findanagency from "../pages/findanagency";
import Marketinelligence from "../pages/marketintelligence";
import Blogs from "../pages/blogs";
import Rent from "../pages/rent";
import Newproject from "../pages/newproject";
import Trends from "../pages/trends";
import Agencyportal from "../pages/agencyportal";
import Privacypolicy from "../pages/privacypolicy";
import About from "../pages/about";
import Careers from "../pages/careers";
import Contactus from "../pages/contactus";
import Agents from "../pages/agents";
import { Routes, Route } from "react-router-dom";
import Cominsoon from "../components/Cominsoon";
import Properties from "../pages/properties";
import Signin from "../pages/authentication/Signin";
import Signup from "../pages/authentication/Signup";
import Userprofile from "../pages/userprofile";
import Privateroute from "../components/Privateroute";
import Listing from "../pages/listing";
import Search from "../pages/search";
import Favourites from "../pages/favourites";
const Allroutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/buy" element={<Buy />} />
        <Route path="/prices" element={<Prices />} />
        <Route path="/findanagency" element={<Findanagency />} />
        <Route path="/marketintelligence" element={<Marketinelligence />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/rent" element={<Rent />} />
        <Route path="/newproject" element={<Newproject />} />
        <Route path="/trends" element={<Trends />} />
        <Route path="/agencyportal" element={<Agencyportal />} />
        <Route path="/contactus" element={<Contactus />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacypolicy" element={<Privacypolicy />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/searchedListing" element={<Search />} />
        <Route path="/favourites" element={<Favourites />} />
        <Route path="/listing/:listingId" element={<Listing />} />
        <Route element={<Privateroute />}>
          <Route path="/profile" element={<Userprofile />} />
        </Route>
      </Routes>
    </>
  );
};

export default Allroutes;
